import React, { useState, useEffect } from "react";
import CheckList from "./Menu/Checklist/CheckList.js";
import CheckSecretChartPW from "./Popup/CheckSecretChartPW.js";
import SecretChart from "./Menu/Secretchart/SecretChart.js";
import SecretChartEdit from "./Menu/Secretchart/SubPage/SecretChartEdit.js";
import DoctorNotice from "./Menu/DoctorNotice/DoctorNotice.js";
import DoctorNoticeRegister from "./Menu/DoctorNotice/SubPage/DoctorNoticeRegister.js";
import Bbs from "./Menu/Bbs/Bbs.js";
import BbsRegister from "./Menu/Bbs/BbsRegister.js";
import BbsDetail from "./Menu/Bbs/BbsDetail.js";
import BbsVote from "./Menu/Bbs/BbsVote.js";
import BbsVoteDetail from "./Menu/Bbs/BbsVoteDetail.js";
import BbsVoteVisualization from "./Menu/Bbs/BbsVoteVisualization.js";
import Bottom from "../../components/Client/Bottom.js";
import HeaderText from "../../components/Client/HeaderText.js";
import "./Client.css";
import { useLocation } from "react-router-dom";
import { EventSourcePolyfill } from "event-source-polyfill";
import CheckSecretChartPw from "./Popup/CheckSecretChartPW.js";
import CheckListFamilyPastChoice from "./Popup/CheckListFamilyPastChoice.js";
import { getServerBaseUrl } from "../../utils/portConfig.js";
import PatientCommunityDetail from "./Menu/Bbs/PatientCommunityDetail.jsx";

const Client = () => {
  const [activeMenu, setActiveMenu] = useState(""); // 활성 메뉴 상태
  const [fromMokLok, setFromMokLok] = useState("");
  const [whenMovingNoticeDetail, setNoticeDetailId] = useState("");
  const [isCommunity, setIsCommunity] = useState(false);
  const [viewsCount, setViewsCount] = useState(0);
  const [bbsDate, setBbsDate] = useState("");
  const [data, setData] = useState([]);
  const [title, setTitle] = useState("");
  const [chkSecretMode, setChkSeccretMode] = useState("");
  const [isSchartOpen, setIsSchartOpen] = useState(true); // 비밀차트 팝업
  const [sData, getSecretData] = useState([]);
  const [secretDate, getSecretDate] = useState("");
  const [patientData, setPatientData] = useState(null); // 환자 정보
  const [weeks, setWeeks] = useState([]);
  const [currentWeek, setCurrentWeek] = useState("");
  const [showTimeline, setShowTimeline] = useState(false);
  const [openFamilyIllChoosePopup, setOpenFamilyIllChoosePopup] = useState(false);
  const [doctorSettingOpen, setDoctorSettingOpen] = useState(false);

  const API_SERVER_URL = `${getServerBaseUrl()}/api/v1`; // API 서버 URL
  const token = localStorage.getItem("token"); // 토큰

  // 커뮤니티 게시글 등록 -> 게시판으로 이동
  const location = useLocation();

  const fetchPatientData = () => {
    const userId = localStorage.getItem("userid");

    // API 엔드포인트 정의
    const API_ENDPOINT = `${API_SERVER_URL}/sse/connect/${userId}`;

    // 요청과 함께 보낼 헤더 설정
    const headers = {
      Authorization: `Bearer ${token}`,
      // 필요한 다른 헤더들을 설정
    };

    // 함수를 통해 EventSource 생성
    const createEventSource = () => {
      return new EventSourcePolyfill(API_ENDPOINT, {
        headers: headers,
        heartbeatTimeout: 3600000,
      });
    };

    // EventSource 인스턴스 생성
    let eventSource = createEventSource();

    eventSource.onopen = () => {
      console.log("EventSource 연결 성공");
      setActiveMenu("체크리스트");
    };

    // 메시지 이벤트 핸들링
    eventSource.onmessage = (event) => {
      // 이벤트 데이터를 파싱하고 상태를 업데이트
      const data = JSON.parse(event.data);

      // 현재 주차 업데이트
      setCurrentWeek(data.currentWeek);

      // 주차 목록 업데이트
      const updatedWeeks = generateWeeks(data.currentWeek);
      setWeeks(updatedWeeks);

      // 환자 데이터 업데이트
      setPatientData(data);
      setActiveMenu("체크리스트");
    };

    // 에러 핸들링 handleLogout();

    eventSource.onerror = (error) => {
      console.error("EventSource 실패:", error);
      eventSource.close();

      if (error.status === 401) {
        console.log("401 Unauthorized 에러가 발생했습니다. 로그아웃을 수행합니다.");
        handleLogout();
      } else {
        // 실패 시 재연결 시도 (예: 5초 후 재시도)
        setTimeout(() => {
          fetchPatientData();
        }, 5000);
      }
    };

    // 컴포넌트가 언마운트될 때 연결을 닫는 것 고려
    return () => {
      eventSource.close();
    };
  };

  useEffect(() => {
    const unsubscribe = fetchPatientData();
    return () => unsubscribe(); // 언마운트 시 구독 해제
  }, []); // 의존성 배열이 비어있으면 컴포넌트가 마운트될 때 한 번 실행됨

  useEffect(() => {
    const { state } = location;

    if (state && state.setFromMokLok) {
      setActiveMenu("게시판");
      setFromMokLok(state.setFromMokLok);
      setNoticeDetailId(state.setNoticeDetailId);
      setViewsCount(state.setViewsCount);
      setBbsDate(state.setBbsDate);
      if (state.isCommunity === "공지") {
        setIsCommunity(false);
      } else {
        setIsCommunity(true);
      }

      window.history.replaceState(null, null, "/");
    }

    if (state && state.setActiveMenu) {
      setActiveMenu(state.setActiveMenu);
      setFromMokLok(state.tabFlag);
      setData(state.data);
      setBbsDate(state.setBbsDate);
      setTitle(state.setTitle);

      window.history.replaceState(null, null, "/");
    }

    if (state && state.gotoEditPage) {
      setActiveMenu("비밀차트");
      if (state.gotoEditPage === "빈칸") {
        setChkSeccretMode("");
      } else {
        setChkSeccretMode(state.gotoEditPage);
      }

      window.history.replaceState(null, null, "/");
    }

    if (state && state.sData) {
      getSecretData(state.sData);
      getSecretDate(state.chartDate);

      window.history.replaceState(null, null, "/");
    }
  }, [location]);

  // 메뉴 클릭 이벤트 핸들러
  const handleMenuClick = (menu) => {
    setFromMokLok("");
    setChkSeccretMode("");
    setActiveMenu(menu);
    if (menu === "비밀차트") {
      setIsSchartOpen(true);
    } else {
      setIsSchartOpen(false);
    }
  };

  const generateWeeks = (selectedWeek) => {
    const weeks = [];
    for (let i = selectedWeek - 1; i <= selectedWeek + 1; i++) {
      if (i >= 1 && i <= 42) {
        // 주차는 1부터 42까지 존재
        const isGray = i > selectedWeek; // 선택된 주차 이후인 경우 회색 표시
        weeks.push({ week: i, isGray }); // 주차 정보를 배열에 추가
      }
    }
    setShowTimeline(true);
    return weeks;
  };

  const openFamilyPopup = () => {
    setOpenFamilyIllChoosePopup(!openFamilyIllChoosePopup);
  };

  const handleClose = () => {
    setIsSchartOpen(false);
    setOpenFamilyIllChoosePopup(false);
  };

  const handlePasswordSubmit = (password) => {
    if (password) {
      handleClose();
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("auth");
    localStorage.removeItem("userid");
    localStorage.removeItem("id");
    localStorage.removeItem("active");
    window.location.reload();
  };

  return (
    <>
      <HeaderText popupOpen={doctorSettingOpen} setPopupOpen={setDoctorSettingOpen} />
      {activeMenu !== "게시판" && (
        <div>
          <div className={`timeline-container ${showTimeline ? "" : "timeline-hidden"}`}>
            <div className="patient-info">
              {patientData && !patientData.hasOwnProperty("status") ? (
                <>
                  <p className="patient-name">
                    환자명: {patientData.patientName}({patientData.age})
                  </p>
                  <p className="due-date">분만예정일: {patientData.birthDueDate}</p>
                </>
              ) : (
                <>
                  <p className="patient-name">환자명: </p>
                  <p className="due-date">분만예정일: </p>
                </>
              )}
            </div>
            {/* 의료이력 */}
            {patientData && !patientData.hasOwnProperty("status") && (
              <div className="family-history">
                <button className="family-history-btn" onClick={openFamilyPopup}>
                  의료이력 선택
                </button>
              </div>
            )}
            {weeks.length !== 0 && (
              <div className="timeline">
                {weeks.map((weekInfo) => (
                  <div key={weekInfo.week} className={`timeline-item ${currentWeek === weekInfo.week ? "selected-week" : ""}`}>
                    <div className={`timeline-circle ${weekInfo.isGray ? "gray-circle" : ""}`}></div>
                    <div className="week-label">{`${weekInfo.week}주`}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="content-container">
            {/* 메뉴 클릭 시 해당 메뉴 컴포넌트를 화면에 출력 */}
            {activeMenu === "체크리스트" && openFamilyIllChoosePopup && <CheckListFamilyPastChoice isOpen={openFamilyIllChoosePopup} patientId={patientData.id} onClose={handleClose} />}
            {activeMenu === "체크리스트" && <CheckList patientData={patientData} />}
            {activeMenu === "비밀차트" && isSchartOpen === true && <CheckSecretChartPw isOpen={isSchartOpen} onPasswordSubmit={handlePasswordSubmit} />}
            {activeMenu === "비밀차트" && patientData && isSchartOpen === false && chkSecretMode === "" && patientData && !patientData.hasOwnProperty("status") && (
              <SecretChart patientData={patientData} />
            )}
            {activeMenu === "비밀차트" && patientData && (chkSecretMode === "등록" || chkSecretMode === "수정") && (
              <SecretChartEdit patientData={patientData} chkSecretMode={chkSecretMode} sData={sData} secretDate={secretDate} />
            )}
            {activeMenu === "환자정보전달" && patientData && patientData && !patientData.hasOwnProperty("status") && (fromMokLok === "" || fromMokLok === "소견취소") && (
              <DoctorNotice patientData={patientData} />
            )}
            {activeMenu === "환자정보전달" && patientData && fromMokLok === "소견등록" && <DoctorNoticeRegister patientData={patientData} fromMokLok={fromMokLok} />}
            {/*{activeMenu === '환자분석' && patientData && <PatientAnalyze />}*/}
          </div>
        </div>
      )}
      {activeMenu === "게시판" && (
        <div style={{ display: fromMokLok === "" || fromMokLok === "공지" || fromMokLok === "커뮤니티" || fromMokLok === "투표목록" || fromMokLok === "환자_커뮤니티" ? "block" : "none" }}>
          <Bbs fromMokLok={fromMokLok} />
        </div>
      )}
      {activeMenu === "게시판" && fromMokLok === "등록" && <BbsRegister />}
      {activeMenu === "게시판" && (fromMokLok === "상세(Community)" || fromMokLok === "상세(Announce)") && (
        <BbsDetail whenMovingNoticeDetail={whenMovingNoticeDetail} isCommunity={isCommunity} fromMokLok={fromMokLok} />
      )}
      {activeMenu === "게시판" && fromMokLok === "상세(환자_커뮤니티)" && (
        <PatientCommunityDetail whenMovingNoticeDetail={whenMovingNoticeDetail} fromMokLok={fromMokLok} setDoctorSettingOpen={setDoctorSettingOpen} />
      )}
      {activeMenu === "게시판" && fromMokLok === "투표" && <BbsVote />}
      {activeMenu === "게시판" && fromMokLok === "투표상세" && <BbsVoteDetail bbsDate={bbsDate} whenMovingNoticeDetail={whenMovingNoticeDetail} />}
      {activeMenu === "게시판" && fromMokLok === "투표그래프" && <BbsVoteVisualization data={data} bbsDate={bbsDate} title={title} />}

      <Bottom activeItem={activeMenu} onMenuClick={handleMenuClick} />
    </>
  );
};

export default Client;
